

module.exports = angular.module('msi.subscriptions.cancel', [
  'ui.router',
  require('@ordergroove/brandy/src/app/modals/confirmation-dialog'),
  require('@ordergroove/brandy/src/app/toasts')
]).name;

angular.module(module.exports)
  .controller('CancelSubscriptionController', require('./cancel-subscription.controller'))
  .component('ogCancelSubscriptionButton', require('./cancel-subscription-button'))
  .config(require('./state'));
